import { render } from "./notificationMessage.vue?vue&type=template&id=064b5c3a&scoped=true"
import script from "./notificationMessage.vue?vue&type=script&lang=js"
export * from "./notificationMessage.vue?vue&type=script&lang=js"

import "./notificationMessage.vue?vue&type=style&index=0&id=064b5c3a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064b5c3a"]])

export default __exports__